import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../../api';
import Navbar from '../../components/navBar';
import './Admin.css';
import { Trash, Edit, Plus } from "lucide-react"; // Icon
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

const API_URL = "/prizes";

export default function AdminPanel() {
  const [prizes, setPrizes] = useState([]);
  const [newPrize, setNewPrize] = useState({ name: '', quantity: 0, probability: 0 });
  const [editing, setEditing] = useState(null);
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("isAuthenticated");

  const fetchPrizes = useCallback(async () => {
    const response = await api.get('/prizes?isAdmin=true');
    setPrizes(response.data);
  }, [])

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, []);




  useEffect(() => {

    if (isLoggedIn) {
      fetchPrizes();
    }

  }, []);



  // Xử lý thêm/sửa giải thưởng
  const handleSubmit = (e) => {
    e.preventDefault();

    // Kiểm tra nếu thiếu thông tin
    if (!newPrize.name.trim()) {
      toast.error("Vui lòng nhập tên giải thưởng!");
      return;
    }
    if (!newPrize.quantity || newPrize.quantity <= 0) {
      toast.error("Số lượng phải lớn hơn 0!");
      return;
    }


    const method = editing !== null ? "put" : "post";
    const url = editing !== null ? `${API_URL}/${editing}` : API_URL;

    api[method](url, newPrize)
      .then((res) => {
        setPrizes((prev) => (editing !== null
          ? prev.map((p) => (p.id === editing ? res.data : p))
          : [...prev, res.data]
        ));
        toast.success(editing !== null ? "Cập nhật thành công!" : "Thêm giải thưởng thành công!");
        setEditing(null);
        setNewPrize({ name: "", quantity: "", probability: "" });
      })
      .catch((err) => {
        console.error("Lỗi khi gửi dữ liệu:", err);
        toast.error("Có lỗi xảy ra!");
      })
      .finally(() => {
        // window.location.reload();
        fetchPrizes();
      });
  };

  // Xử lý xoá giải thưởng
  const handleDelete = (id) => {
    const prize = prizes.find((p) => p.id === id);
    const confirmDelete = window.confirm(`Bạn có chắc chắn muốn xóa giải thưởng "${prize.name}" không?`);
    if (confirmDelete) {
      api.delete(`${API_URL}/${id}`)
        .then(() => {
          setPrizes(prizes.filter((p) => p.id !== id));
          toast.success("Xóa thành công!");
        })
        .catch((err) => {
          console.error("Lỗi khi xóa:", err);
          toast.error("Xóa thất bại!");
        });
    }
  };

  // Xử lý chỉnh sửa
  const handleEdit = (prize) => {
    setNewPrize(prize);
    setEditing(prize.id);
  };


  return (
    <>
      <Navbar />
      <div className="admin-container">
        <h2 className="admin-title">🎯 Quản lý Giải thưởng</h2>
        <form onSubmit={handleSubmit} className="form-container">
          <input
            type="text"
            placeholder="Tên giải thưởng"
            value={newPrize.name}
            onChange={(e) => setNewPrize({ ...newPrize, name: e.target.value })}
            required
          />
          <input
            type="number"
            placeholder="Số lượng 2,3,4..."
            value={newPrize.quantity}
            onChange={(e) => setNewPrize({ ...newPrize, quantity: parseInt(e.target.value) })}
            required
          />
          <input
            type="number"
            step="0.01"
            placeholder="Tỷ lệ từ > 0 và < 1"
            value={newPrize.probability}
            onChange={(e) => setNewPrize({ ...newPrize, probability: parseFloat(e.target.value) })}
            required
          />
          <button className={!editing ? 'btn-submit' : ''} type="submit">
            {editing !== null ? "Cập nhật" : "Thêm "}
            {editing === null && <Plus size={16} />}
          </button>

          {editing !== null && <button className='btn-submit' onClick={() => {
            setEditing(null);
            setNewPrize({ name: "", quantity: "", probability: "" });
          }} >
            Huỷ bỏ
          </button>}
        </form>

        <table className="prize-table">
          <thead>
            <tr>
              <th>Tên</th>
              <th>SL</th>
              <th>Tỷ lệ</th>
              <th>Hành động</th>
            </tr>
          </thead>
          <tbody>
            {prizes.map((prize) => (
              <tr key={prize.id}>
                <td>{prize.name}</td>
                <td>{prize.quantity}</td>
                <td>{prize.probability}</td>
                <td className="action-buttons">
                  <button className="edit-btn" onClick={() => handleEdit(prize)}>
                    <Edit size={16} />
                  </button>
                  <button className="delete-btn" onClick={() => handleDelete(prize.id)}>
                    <Trash size={16} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <ToastContainer position="top-right" autoClose={5000} />
      </div>
    </>

  );
}
